import { refreshAccessToken } from "./RefreshTokenService";

export const baseUrl = "https://tdawebapi.azurewebsites.net";
// export const baseUrl = "https://localhost:7210";

const isTokenExpired = () => {
  const expiresAt = localStorage.getItem("expires_at");

  return expiresAt && Date.now() > parseInt(expiresAt, 10);
};

export async function getTokenFromLocalStorage() {
  const isExpired = isTokenExpired();
  if (isExpired != null && isExpired) {
    try {
      const access_token = await refreshAccessToken();

      if (access_token) {
        return access_token;
      }
    } catch (error) {
      console.error("Failed to refresh token", error);
    }
  } else {
    const token = localStorage.getItem("token");
    if (token) {
      return token;
    }
  }

  // If no token found, redirect to login

  return null;
}
